import { Injectable } from '@angular/core';
import { AuthenticationService } from '@app/auth/services/authentication.service';
import { UserLevel } from '@app/core/models/user-level';
import { MenuService } from '@app/menu/services/menu.service';
import { RouterService } from '@app/routing/router.service';
import { CommandDefinition, CommandHelper, CommandResultEntry } from '@app/shared/quick-commands';
import { RequiredAuthorization } from '@app/shared/services/authorization.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class FallbackToSearchCommand implements CommandDefinition<any> {
  authorization: RequiredAuthorization = {
    allowedUserLevels: [UserLevel.SystemAdmin, UserLevel.ServiceProviderAdmin, UserLevel.EnterpriseAdmin],
  };
  fallback = true;
  icon = 'far fa-search';
  label = 'quickCommands.commands.fallbackToSearch';
  name = 'fallback-to-search';

  constructor(
    private authenticationService: AuthenticationService,
    private menuService: MenuService,
    private routerService: RouterService,
    private translateService: TranslateService
  ) {}

  action(query: string, [type]: [string]) {
    if (type != null) {
      const { url } = this.routerService.resolveLink(`search-results-for-${type}`, { query }, true);
      this.routerService.navigateByUrl(url);

      return CommandHelper.close();
    }

    let values: CommandResultEntry[] = [];

    if (this.authenticationService.userIsEnterpriseAdmin()) {
      values.push(this.enterpriseResult(query));
    } else {
      values.push(this.resellerResult(query));

      if (this.menuService.isActive(UserLevel.EnterpriseAdmin)) {
        values.unshift(this.enterpriseResult(query));
      }
    }

    return CommandHelper.list({
      values,
    });
  }

  private enterpriseResult(query: string): CommandResultEntry {
    return {
      label: this.translateService.instant(`quickCommands.commands.fallbackToSearch.enterprise`, {
        query,
      }),
      value: 'enterprise',
    };
  }

  private resellerResult(query: string): CommandResultEntry {
    return {
      label: this.translateService.instant(`quickCommands.commands.fallbackToSearch.reseller`, {
        query,
      }),
      value: 'reseller',
    };
  }
}
